import { Classificacao } from 'model/classificacao/Classificacao';
import { QueryParamsFormatter } from 'service/QueryParamsFormatter';
import { ApiAxios } from '../ApiAxios';
import { Api } from '../Api';
import { CriacaoClassificacaoDTO } from 'model/classificacao/CriacaoClassificacaoDTO';


export interface ClassificacoesQueryParams {
  id?: number[];
  descricao?: string;
  idPai?: number[];
  idReino?: number[];
  idUnidade?: number[];
}


export class ApiClassificacao {
  static async classificacoes(query?: ClassificacoesQueryParams): Promise<Classificacao[]> {
    const queryParams = QueryParamsFormatter.format(query ?? {});
    const response = await ApiAxios.instance.get(`/reinos/${Api.REINO_PADRAO}/classificacoes?${queryParams}`)

    return response.data;
  };

  static async getClassificacoesByReino(query?: ClassificacoesQueryParams): Promise<Classificacao[]> {
    const response = await ApiAxios.instance.get(`/reinos/${Api.REINO_PADRAO}/classificacoes/reino/${Api.REINO_PADRAO}`)

    return response.data;
  };

  static async adicionar(classificacao: CriacaoClassificacaoDTO): Promise<Classificacao> {
    console.log('Classificacao: ' + classificacao);
    const response = await ApiAxios.instance.post(`/reinos/${Api.REINO_PADRAO}/classificacoes`, classificacao);
    return response.data;
  };

  static atualizar = async (id: number, data: any) => {
    console.log(`Atualizar: ID: ${id}, Data: ${data}`);
    const response = await ApiAxios.instance.put(`/reinos/${Api.REINO_PADRAO}/classificacoes/${id}`, data);
    return response.data;
  };
  
  static deletar = async (id: number) => {
    const response = await ApiAxios.instance.delete(`/reinos/${Api.REINO_PADRAO}/classificacoes/${id}`);
    return response.data;
  };

}
